const lang = {
  breadcrumb: {
    management: 'データ取込管理',
  },
  list: {
    page_title: 'データ取込管理',
    explain: '森林経営計画書ファイル、森林施業団地Shapeファイルのデータ取込を行う画面です。',
    paginate_text: '全 {total} 件中 {from} 件 〜 {to} 件を表示',
    search: {
      free_word: 'フリーワード検索',
    },
    label: {
      no: 'No',
      forest_management_complex_name: '団地名',
      forest_group: '林班',
      small_forest_group: '小班',
      branch_group: '小班番号',
      compensate_group: '小班枝番',
      fcs_tree_species: '樹種',
      area: '面積（ha）',
      operation_history_thinning_area: '間伐面積',
      forest_age: '林齢（年生）',
      tree_height: '樹高（m）',
      position: '地位',
      accumulation: '材積量（㎥）',
      tree_volume_increment: '材積成長量（㎥/ha）',
      fcs_operation_id: '施業履歴（年）',
      operation_history_thinning_year: '施業履歴間伐時期（年）',
      felling_planning_year: '間伐計画時期（年）',
    },
  },
  import: {
    page_title: '',
    page_title_confirm: '',
    button: {
      return_to_import: '閉じる',
    },
    placeholder: {},
    label: {},
    // プルダウン初期値
    select_forest_complex: '森林施業団地を選択してください',
    setting_default_text: '+森林施業団地名を入力する',
    modal: {
      complete_update_master: {
        title: '森林施業団地更新完了',
        message: '森林施業団地が正常に更新されました。',
      },
      complete_update_shapefile: {
        title: 'Shapeファイル取込完了',
        message: 'Shapeファイルの取り込みが正常に完了しました。',
      },
      complete_update_csv: {
        title: '取込完了',
        // 下記messageはサーバサイドで生成しているので使用していない
        message: 'データ取り込みが正常に完了しました。',
        close_button: '閉じる',
      },
    },
    message_error: '取込時にエラーが発生したため、取込を取り消しました。エラーを排除し、再度取込をお願いいたします。',
    message_alert_csv: '森林施業団地を選択してください。',
    copy_to_clipboard_button_title: 'エラーメッセージをコピーする',
    // 森林背用団地マスタ管理 削除確認メッセージ
    register_request: {
      title: {
        setting: '森林施業団地マスタ管理',
      },
      message_confirm_to_delete:
        '保存済みのマスタを削除すると、それに紐付く取込済みの森林経営計画データも削除され、復元はできません。本当に削除しますか？',
      add: '森林施業団地名を追加する',
      save: '保存',
      cancel: 'キャンセル',
    },
  },
  tab1: {
    tab_title: '森林経営計画書ファイル取込',
    button_title: 'CSVインポート',
  },
  tab2: {
    tab_title: '森林施業団地Shapeファイル取込',
    button_title: 'GISインポート',
  },
}

export default lang
